import { CONFIG } from "../constants"

const DEBUG = false

export default class WebSocketClient {

  static myInstance: WebSocketClient
  private userId: string
  private userName: string
  public webSocket?: WebSocket
  public eventEl: any
  public unReadMessage: boolean
  private pingInterval: any

  constructor(userId?: string, userName?: string) {
    this.unReadMessage = false
    this.userId = userId ? userId : window.localStorage[CONFIG.PERSON_TOKEN]
    this.userName = userName ? userName : window.localStorage[CONFIG.USERNAME_TOKEN]
    this.checkOpen()
    this.eventEl = document.createTextNode('')
  }

  public checkOpen() {

    if (this.webSocket) {
      if (this.webSocket.readyState === this.webSocket.CONNECTING) {
        if (DEBUG) console.log('Socket: already connecting, exiting')
        return
      } else if (this.webSocket.readyState === this.webSocket.OPEN) {
        if (DEBUG) console.log('Socket: already open, exiting')
        return
      } else if (this.webSocket.readyState === this.webSocket.CLOSING) {
        if (DEBUG) console.log('Socket: is closing ----- todo: reopen when closed')
        return
      } else if (this.webSocket.readyState === this.webSocket.CLOSED) {
        if (DEBUG) console.log('Socket: is closed ----- todo: reopen when closed')
      }
    }

    if (!this.userId) {
      if (DEBUG) console.log('Socket: No token, exiting')
      return
    }

    this.openSocket()

  }

  private openSocket(extraMessage?: any) {
    if (DEBUG) console.log("WEB_SOCKET_ENDPOINT", CONFIG.WEB_SOCKET_ENDPOINT)
    this.webSocket = new WebSocket(CONFIG.WEB_SOCKET_ENDPOINT)
    if (DEBUG) console.log('socket new WebSocket: ' + this.webSocket.readyState)

    // console.log('Tried opening websocket')
    this.webSocket.onerror = (err) => {
      console.log(err)
      if (this.webSocket) {
        console.log('socket error: ' + this.webSocket.readyState)
      }
    }


    this.webSocket.onopen = () => {
      // console.log('Sending', JSON.stringify(mess))

      if (this.webSocket) {
        const mess = {
          type: 'session_init',
          user_name: this.userName,
          user_id: this.userId,
        }
        if (DEBUG) console.log('socket onopen: ' + this.webSocket.readyState)
        this.webSocket.send(JSON.stringify(mess))
        if (extraMessage) {
          // We just sent the init call - wait for a short while to let first message arrive at websocket server
          // TODO - it would be better to wait for session_init confirmation before sending next message
          setTimeout(() => {
            if (this.webSocket) {
              this.webSocket.send(JSON.stringify(extraMessage))
              if (DEBUG) console.log('Sent message after open')
            }
          }, 200)
        }
      }
    }

    // Use addEventListener in places where message matters, e.g VideoMeeting
    // This is just for debugging
    // this.webSocket.onmessage = (message) => {
    //   const jsonMess = JSON.parse(message.data)
    //   // console.log(jsonMess)
    // }

    this.webSocket.onclose = () => {
      if (DEBUG) {
        console.log('socket closed')
      }
      clearInterval(this.pingInterval)
    }

    this.pingInterval = setInterval(() => {
      if (this.webSocket) {
        if (this.webSocket?.readyState === this.webSocket?.OPEN) {
          const mess = {
            type: 'ping'
          }
          if (DEBUG) console.log(JSON.stringify(mess))
          this.webSocket.send(JSON.stringify(mess))
        } else {
          console.log('webSocket not open')
        }
      } else {
        console.log('No webSocket!')
      }
    }, 30000)
  }

  /**
   * @returns {WebSocketClient}
   */
  static getInstance(): WebSocketClient {
    if (WebSocketClient.myInstance == null) {
      if (DEBUG) console.log('HD: creating new instance')
      WebSocketClient.myInstance = new WebSocketClient()
    } else {
      if (DEBUG) console.log('HD: checking existing instance')
      WebSocketClient.myInstance.checkOpen()
    }
    return this.myInstance
  }
}
